import React from "react";
import { Helmet } from "react-helmet-async";

// Reusable SEO component: title, description, canonical, Open Graph, Twitter, and optional JSON-LD.
const Seo = ({ title, description, image, path = "", type = "website", lang = "de", jsonLd = null, noindex = false }) => {
  const siteName = "My Own Cuvée";
  const base = "https://myowncuvee.com";
  const url = base + path;
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const img = image || `${base}/og-image.jpg`;
  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {noindex ? <meta name="robots" content="noindex,nofollow" /> : <link rel="canonical" href={url} />}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
};

export default Seo;
